import FeaturedDeviation from './FeaturedDeviationBox';
import { withFeatureBranch } from '@wix/da-shared-react/pkg/redux/flags';
import FeaturedDeviation__premium_folders from '../FeaturedDeviation__premium_folders';

export default withFeatureBranch({
  premium_folders: FeaturedDeviation__premium_folders,
})(FeaturedDeviation);
